import React from "react";
import { FormattedMessage } from 'react-intl';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import Modal from '../general/Modal';
import { logErrorToMyService } from './errorLog';
import { AUTH_EXPIRED_EVENT, AUTH_EXPIRED_WINDOW_FLAG } from '../utils';


class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            authExpired: false,
        };

        this.handleAuthExpired = this.handleAuthExpired.bind(this);
    }

    static getDerivedStateFromError(error) {
        if (typeof window !== 'undefined' && window[AUTH_EXPIRED_WINDOW_FLAG]) {
            return { hasError: false, authExpired: true };
        }
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        logErrorToMyService(error, errorInfo);
    }

    componentDidMount() {
        if (typeof window === 'undefined') {
            return;
        }
        window.addEventListener(AUTH_EXPIRED_EVENT, this.handleAuthExpired);
    }

    componentWillUnmount() {
        if (typeof window === 'undefined') {
            return;
        }
        window.removeEventListener(AUTH_EXPIRED_EVENT, this.handleAuthExpired);
    }

    handleAuthExpired() {
        this.setState({
            hasError: false,
            authExpired: true,
        });
    }

    render() {
        const isAuthExpiredGlobally =
            typeof window !== 'undefined' && Boolean(window[AUTH_EXPIRED_WINDOW_FLAG]);

        if (isAuthExpiredGlobally || this.state.authExpired) {
            // For auth-expired flows:
            // - nested boundaries should not render generic crash UI
            // - root boundary must keep rendering App so the auth-expired modal can be shown
            if (this.props.preserveChildrenOnAuthExpired) {
                return this.props.children;
            }
            return null;
        }

        if (this.state.hasError) {
            // You can render any custom fallback UI
            return <Modal>
                <Dialog>
                    <div className="text-red-500">
                        <i className="material-icons">error</i>
                        <h1 >
                            <FormattedMessage
                                id='app.errors.title'
                                defaultMessage={'Something went wrong.'}
                            />
                        </h1>
                    </div>
                    <p>
                        <FormattedMessage
                            id='app.errors.message'
                            defaultMessage={'If the error persist, please contact administrator.'}
                        />
                    </p>
                    <DialogActionsBar>
                        <button className='k-button k-button-md k-button-solid k-button-solid-base k-rounded-md' onClick={
                            () => {
                                console.log('please close the dialog')
                                this.setState({ hasError: false })
                            }
                        }>OK</button>
                    </DialogActionsBar>
                </Dialog>
            </Modal >;

        }

        return this.props.children;
    }
}

export default ErrorBoundary;
